import * as yup from 'yup';

function serviceType(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'EDITFORM_SERVICETYPE_FIELD_IS_REQUIRED',
        defaultMessage: 'Service Type is required',
      }),
    )
    .max(
      64,
      formatMessage({
        id: 'EDITFORM_SERVICETYPE_FIELD_MAX_CHARS_64',
        defaultMessage: 'Service Type should be less than 64 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'EDITFORM_STATUS_FIELD_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      serviceType: serviceType(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
